module.exports = __webpack_public_path__ + "img/Welcome.be4810e2.png";